// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__379GH","col":"CardReaderDesc_col__2FC95","label":"CardReaderDesc_label__1LbUV"};